import Icon from '../components/Icon.vue'

Icon.register({"apple":{"width":1408,"height":1792,"paths":[{"d":"M1393 1215q-39 125-123 250-129 196-257 196-49 0-140-32-86-32-151-32-61 0-142 33-81 34-132 34-152 0-301-259-147-261-147-503 0-228 113-374 113-144 284-144 72 0 177 30 104 30 138 30 45 0 143-34 102-34 173-34 119 0 213 65 52 36 104 100-79 67-114 118-65 94-65 207 0 124 69 223t158 126zM1017 42q0 61-29 136-30 75-93 138-54 54-108 72-37 11-104 17 3-149 78-257 74-107 250-148 1 3 2.5 11t2.5 11q0 4 0.5 10t0.5 10z"}]}})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/apple.js
// module id = YbF4
// module chunks = 1